import React from "react";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const PhoneQuestion = ({
  question,
  id,
  questionIndex,
  module,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={(html) => {
            handleQuestionChange(html);
          }}
        />
      </div>
      <div className="nameAns_container">
        <div className="Name">{question.placeHolder}</div>
      </div>
    </>
  );
};

export default PhoneQuestion;
